import React from 'react';
import SectionHeading from './components/SectionHeading/SectionHeading';
import Badge from './components/Badge/Badge';
import { calculatorPropTypes } from './CalculatorPropTypes';
import * as styles from './Calculator.module.scss';
const Calculator = ({
  badge,
  heading,
  description,
  children
}) => {
  if (!heading && !description && !children) {
    return null;
  }
  return /*#__PURE__*/React.createElement("section", {
    className: styles.root
  }, badge && /*#__PURE__*/React.createElement(Badge, {
    badge: badge,
    classname: styles.rootBadge
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.rootMain
  }, heading && /*#__PURE__*/React.createElement(SectionHeading, {
    classname: styles.rootHeading,
    description: description,
    heading: heading
  }), children));
};
export default Calculator;